//Telas
import TAnexos_list from "../anexos/anexos_list";

function TSolicitacao_det_aba_anexos({ solicitacao }) {
  return (
    <div className="m-1">
      <TAnexos_list solicitacao={solicitacao} />
    </div>
  );
}

export default TSolicitacao_det_aba_anexos;
